import script from "./MitikuinSecccionOne.vue?vue&type=script&setup=true&lang=js"
export * from "./MitikuinSecccionOne.vue?vue&type=script&setup=true&lang=js"

import "./MitikuinSecccionOne.vue?vue&type=style&index=0&id=3853facf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3853facf"]])

export default __exports__